import {Trans} from '@lingui/macro';
import React, {FC} from 'react';

import {DropdownBoxCoordinator} from '../../../../../libs/shared/ui/src/components/boxedInputs/dropdownBoxCoordinator';
import {SimpleDropdown} from '../../../../../libs/shared/ui/src/components/dropdowns/simpleDropdown';
import {SimpleDropdownItem} from '../../../../../libs/shared/ui/src/components/dropdowns/simpleDropdownItem';
import {ChannelReplyModesEnum} from '../../../../models/api/channelBehaviorsModel';
import {ChannelCustomModel} from '../../../../models/api/channelModel';
import {SettingsFieldLine} from '../../../common/settingsFieldLine';
import {SettingsCommonChannelFieldProps} from '../settingsCommonChannelFields';

/*
 * Props.
 */

interface ChannelReplyModeFieldProps extends SettingsCommonChannelFieldProps<ChannelCustomModel> {}

/*
 * Component.
 */

const possibleReplyModes = [ChannelReplyModesEnum.SAME_CHANNEL, ChannelReplyModesEnum.UNSUPPORTED] as const;

export const ChannelReplyModeField: FC<ChannelReplyModeFieldProps> = (props) => {
  const value = props.edited.preferences.replyMode;
  return (
    <SettingsFieldLine
      title={<Trans id="settingschannel-channelreplymode-title">Channel reply mode</Trans>}
      subtitle={
        <Trans id="settingschannel-channelreplymode-subtitle">
          Choose how this channel can be used to reply to a message
        </Trans>
      }
      content={
        <DropdownBoxCoordinator
          label={null}
          value={replyModeRenderers[value]}
          possibleValues={Object.values(replyModeRenderers)}
          renderDropdown={(popoverProps) => (
            <SimpleDropdown {...popoverProps}>
              {possibleReplyModes.map((v) => (
                <SimpleDropdownItem
                  key={v}
                  isChecked={v === value}
                  onSelect={() => {
                    props.onPreferencesChange({
                      replyMode: v,
                    });
                  }}
                >
                  {replyModeRenderers[v]}
                </SimpleDropdownItem>
              ))}
            </SimpleDropdown>
          )}
        />
      }
    />
  );
};

const replyModeRenderers = {
  [ChannelReplyModesEnum.SAME_CHANNEL]: (
    <Trans id="settingschannel-channelreplymode-samechannel">This channel</Trans>
  ),
  [ChannelReplyModesEnum.UNSUPPORTED]: (
    <Trans id="settingschannel-channelreplymode-unsupported">Cannot reply</Trans>
  ),
};
